
import Vue, { PropType } from 'vue';
import { Button, TimelineItem, Icon } from '@descomplica/vue-components';
import { TabType } from './types';

export default Vue.extend({
  components: {
    TextButton: Button,
    TimelineItem,
    Icon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: null,
    },
    enabled: {
      type: Boolean,
      default: true,
    },
    nextTab: {
      type: String as PropType<TabType>,
      default: null,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasContent(): boolean {
      return !!this.url || this.enabled || !!this.subtitle;
    },
  },
  methods: {
    goToNextTab() {
      this.$emit('goToNextTab', this.nextTab);
    },
    openInNew(url: string) {
      window.open(url, '_blank', 'noopener,noreferrer');
    },
  },
});
